// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 86 ? "7069e3e8" : chunkId) + "." + {"86":"787fdaa8b6ec3ca9","139":"e0b8da9815ba2cf2","285":"9c25e6c4d13e5690","781":"e6db497ff129b362"}[chunkId] + ".js";
};